<template>
    <div class="container mx-auto px-4">
        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">{{ __('Új felhasználó') }}</h1>

        <div class="mb-8 md:gap-8 md:grid md:grid-cols-2">
            <div class="flex flex-col md:items-center">
                <h2 class="font-semibold mb-8 uppercase">{{ __('Belépési adatok') }}</h2>

                <c-control-text class="text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="email" required type="email"
                                v-bind:invalid="!!requestStore.errors?.email || (user.email.length > 0 && !validEmail)"
                                v-bind:label="__('E-mail cím')"
                                v-bind:placeholder="__('placeholders.email')"
                                v-model="user.email"
                                v-on:keyup="validateEmail"
                />
                <span class="px-1 text-error text-xs" v-if="user.email.length > 0 && !validEmail">
                    {{ __('Az email cím formátuma nem megfelelő.') }}
                </span>

                <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight h-auto py-2 text-center !text-base" class-label="mb-2" name="password" placeholder="**********" type="password"
                                v-bind:invalid="!!requestStore.errors?.password || (user.password.length > 0 && user.password.length < 8)"
                                v-bind:label="__('Jelszó')"
                                v-model="user.password"
                />
                <span class="px-1 text-error text-xs" v-if="user.password.length > 0 && user.password.length < 8">
                    {{ __('A jelszó legalább :length karakterből kell álljon.', { 'length' : 8 }) }}
                </span>

                <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight h-auto py-2 text-center !text-base" class-label="mb-2" name="password_confirmation" placeholder="**********" type="password"
                                v-bind:invalid="!!requestStore.errors?.password_confirmation || (user.password.length > 0 && user.password !== user.passwordConfirmation)"
                                v-bind:label="__('Jelszó újra')"
                                v-model="user.passwordConfirmation"
                />
                <span class="px-1 text-error text-xs" v-if="user.password.length > 0 && user.password !== user.passwordConfirmation">
                    {{ __('A jelszavak nem egyeznek.') }}
                </span>

                <c-control-select class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight h-auto py-2 text-center !text-base" class-label="mb-2" name="role"
                                  v-bind:invalid="!!requestStore.errors?.role"
                                  v-bind:label="__('Szerepkör')"
                                  v-bind:options="roleOptions"
                                  v-model="user.role"
                                  v-on:update:model-value="resetResellerValues()"
                />
            </div>

            <div class="flex flex-col md:items-center md:mt-0 mt-8">
                <h2 class="font-semibold mb-8 uppercase">{{ __('Személyes adatok') }}</h2>

                <c-control-text class="text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="lastname" required type="text"
                                v-bind:invalid="!!requestStore.errors?.lastname"
                                v-bind:label="__('Vezetéknév')"
                                v-bind:placeholder="__('placeholders.lastname')"
                                v-model="user.lastname"
                />

                <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="firstname" required type="text"
                                v-bind:invalid="!!requestStore.errors?.firstname"
                                v-bind:label="__('Keresztnév')"
                                v-bind:placeholder="__('placeholders.firstname')"
                                v-model="user.firstname"
                />

                <c-control-text class="mt-8 text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="phone" required type="text"
                                v-bind:invalid="!!requestStore.errors?.phone"
                                v-bind:label="__('Telefonszám')"
                                v-bind:placeholder="__('placeholders.phone')"
                                v-model="user.phone"
                />
            </div>
        </div>

        <div v-if="user.role === 'reseller'">
            <h2 class="font-semibold mb-8 uppercase">{{ __('Egyéb adatok') }}</h2>

            <div class="gap-8 grid grid-cols-2">
                <c-control-select class="text-center w-full" class-field="bg-white border-b border-highlight h-auto py-2 text-center !text-base" class-label="mb-2" name="delivery_time"
                                  v-bind:options="deliveryTimeOptions"
                                  v-bind:label="__('Mikor kéri a kiszállítást?')"
                                  v-if="user.role === 'reseller'"
                                  v-model="user.delivery_time"
                />

                <c-control-select class="text-center w-full" class-field="bg-white border-b border-highlight h-auto py-2 text-center !text-base" class-label="mb-2" name="shipping_zone"
                                  v-bind:options="shippingZoneOptions"
                                  v-bind:label="__('Kiszállítási zóna')"
                                  v-if="user.role === 'reseller'"
                                  v-model="user.shipping_zone"
                />


                <c-control-number class="mt-8 mx-auto text-center w-full" class-field="bg-white border-b border-highlight text-center h-auto py-2 !text-base" class-label="mb-2" name="shipping_cost" placeholder="1000"
                                  v-bind:invalid="!!requestStore.errors?.shipping_cost"
                                  v-bind:label="__('Kiszállítási díj (bruttó)')"
                                  v-bind:min="1"
                                  v-if="user.role === 'reseller'"
                                  v-model="user.shipping_cost"
                />
            </div>
        </div>

        <c-button class="bg-slate-800 border-2 border-slate-800 font-semibold hover:bg-highlight hover:border-highlight mb-4 mt-8 mx-auto normal-case px-4 py-2 rounded-none table text-center !text-lg text-white transition-colors w-48"
                  v-bind:disabled="user.firstname.length === 0 || user.lastname.length === 0 || user.phone.length === 0 || !validEmail || (user.password.length > 0 && user.password.length < 8) || (user.password.length > 0 && user.password !== user.passwordConfirmation)"
                  v-on:click="submit"
        >
            {{ __('Mentés') }}
        </c-button>
    </div>
</template>

<script setup lang="ts">
    import {  ref } from 'vue';
    import {
        CButton,
        CControlNumber,
        CControlSelect,
        CControlText,
    } from '@teamfurther/cinderblock';
    import UserRepository from '../../repositories/UserRepository';
    import { useRequestStore } from '../../stores/request';

    const deliveryTimeOptions = [
        { label: '-', value: null },
        { label: '07:00', value: '0700' },
        { label: '07:30', value: '0730' },
        { label: '08:00', value: '0800' },
        { label: '08:30', value: '0830' },
        { label: '09:00', value: '0900' },
        { label: '09:30', value: '0930' },
        { label: '10:00', value: '1000' },
        { label: '10:30', value: '1030' },
        { label: '11:00', value: '1100' },
        { label: '11:30', value: '1130' },
        { label: '12:00', value: '1200' },
        { label: '12:30', value: '1230' },
        { label: '13:00', value: '1300' },
        { label: '13:30', value: '1330' },
        { label: '14:00', value: '1400' },
        { label: '14:30', value: '1430' },
        { label: '15:00', value: '1500' },
        { label: '15:30', value: '1530' },
        { label: '16:00', value: '1600' },
    ];
    const roleOptions = [
        { label: 'Adminisztrátor', value: 'admin' },
        { label: 'Viszonteladó', value: 'reseller' },
        { label: 'Boltos', value: 'shop' },
        { label: 'Felhasználó', value: 'user' },
    ];
    const shippingZoneOptions = [
        { label: '-', value: null },
        { label: 'I. zóna', value: 'i' },
        { label: 'II. zóna', value: 'ii' },
        { label: 'III. zóna', value: 'iii' },
        { label: 'IV. zóna', value: 'iv' },
    ];
    const user = ref<object>({
        email: '',
        firstname: '',
        lastname: '',
        password: '',
        passwordConfirmation: '',
        phone: '',
    });
    const userRepository = new UserRepository();
    const requestStore = useRequestStore();
    const validEmail = ref<boolean>(true);

    function resetResellerValues() {
        if (user.value.role === 'reseller') {
            return;
        }

        user.value.delivery_time = null;
        user.value.shipping_cost = null;
        user.value.shipping_zone = null;
    }

    async function submit() {
        user.value = await userRepository.store(user.value);
    }

    function validateEmail() {
        validEmail.value = !!user.value.email.match(/\S+@\S+\.\S+/);
    }
</script>
